import React from 'react';
import PropTypes from 'prop-types';

const ExpirationSection = ({ download, label, expirationDate, startDate }) => (
  <div className="col-md-3 col-xs-6">
    {download && (
      <p className="margin-0">
        <strong>{label.expired}:</strong>
        {expirationDate}
      </p>
    )}
    <p className="margin-0">
      <strong>{label.add}:</strong>
      {startDate}
    </p>
  </div>
);

ExpirationSection.propTypes = {
  download: PropTypes.bool,
  label: PropTypes.object,
  expirationDate: PropTypes.string,
  startDate: PropTypes.string,
};

export default ExpirationSection;
